<div class="announcement-modal">
  <div class="modal-header">
    <h3 class="modal-title" i18n="@@AllMessages">All Messages</h3>
    <button
      type="button"
      class="light-icon-button close"
      aria-label="Close"
      (click)="activeModal.close(false)"
      ngbAutoFocus
    >
      <i class="ico-cancel AA-standard-grey" aria-hidden="true"></i>
    </button>
  </div>
  <div class="modal-body">
    @for (annPage of announcements | keyValue; track annPage; let keyIndex = $index) {
      <div class="announcement">
        <h2
          class="announcement_header"
          [ngClass]="{ first_header: keyIndex === 0 && !showTravelAdviceCondition }"
        >
          {{ annPage?.value[0]?.name }}
        </h2>
        <ul class="announcements_list">
          @if (annPage.value) {
            @for (ann of annPage.value; track ann; let i = $index) {
              <li>
                <span [innerHTML]="ann?.config?.message | safeHtml: 'html'"></span>
                @if (ann?.config?.messageLink) {
                  <span class="message-link" i18n="@@announcementsMessageLink">
                    Click
                    <a target="_blank" tabindex="0" role="link" [href]="ann?.config?.messageLink">{{
                      ann?.config?.messageLink
                    }}</a>
                    for more information
                  </span>
                }
                @if (ann.clickToConfirm) {
                  <div
                    class="announcement_close"
                    (click)="onDeleteAnnouncement(ann.id)"
                    (keydown.enter)="onDeleteAnnouncement(ann.id)"
                    attr.aria-label="Close {{ ann?.config?.message }} announcement"
                    tabindex="0"
                    role="button"
                  >
                    <i class="ico-cancel"></i>
                  </div>
                }
                @if (ann.userCanSupress && !ann.clickToConfirm) {
                  <div>
                    <mat-checkbox
                      (click)="onSuppressAnnouncement(ann.id)"
                      class="light-accent"
                      color="primary"
                      [id]="checkboxId + '_' + keyIndex + '_' + i"
                      i18n="@@suppressAnnouncement"
                      aria-label="I have read the message, do not display again"
                    >
                      I have read the message, do not display again
                    </mat-checkbox>
                  </div>
                }
              </li>
            }
          }
        </ul>
      </div>
    }
  </div>
</div>
